import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@cmps/ng-bootstrap';
import {
    CmpsCardComponentModule,
    CmpsCardHeaderRowComponentModule,
    CmpsInsightCoachingPerformanceModule,
    CmpsPeriodCompareModule,
    CmpsPopulationCompareModule,
} from '@cmps/ng-kit';
import { CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { CmpsInsightExplorerModule } from '../insight-explorer/insight-explorer.module';

import { MyPerformanceCardComponent } from './my-performance-card.component';
import { TranslationIdMap } from './my-performance-card.i18n';
import { CmpsPeriodCompareDialogComponent } from './period-compare-dialog/period-compare-dialog.component';
import { CmpsPopulationCompareDialogComponent } from './population-compare-dialog/population-compare-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        CmpsCommonModule,
        CmpsCardComponentModule,
        CmpsCardHeaderRowComponentModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsInsightCoachingPerformanceModule,
        CmpsPeriodCompareModule,
        CmpsIconModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        CmpsInsightExplorerModule,
        CmpsPopulationCompareModule,
    ],
    declarations: [
        MyPerformanceCardComponent,
        CmpsPeriodCompareDialogComponent,
        CmpsPopulationCompareDialogComponent,
    ],
    exports: [MyPerformanceCardComponent],
})
export class CmpsMyPerformanceCardModule {}
